import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MfaOtpForm',
  props: {
    codeInputText: null,
    submitButtonText: null,
    showSpinner: { type: Boolean },
    errorMessage: null
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const formData = ref<IMfaOtpForm>({
    otpCode: null
});




const onSubmit = () => emit('submit', formData.value);

return { __sfc: true,formData, emit, onSubmit }
}

})